import { render } from "./SpeakingView.vue?vue&type=template&id=79621950&ts=true"
import script from "./SpeakingView.vue?vue&type=script&lang=ts"
export * from "./SpeakingView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__